import _ from 'lodash'
import api from '../utils/api/api'

const state = {
    unlocks: {},
    pending: [],
    batchTimer: null,
    revealPending: [],
    revealBatchTimer: null,
    isRevealingBulk: false,
}

const mutations = {
    'unlocks:set': function (state, { quotaType,  keyIds, data }) {
        const key = `${quotaType}:${keyIds.join(':')}`
        _.set(state.unlocks, key, data)
    },
    setRevealingBulk: function (state, loading) {
        state.isRevealingBulk = loading
    },
    'unlocks:setRevealLoading': function (state, { quotaType,  keyIds, loading }) {
        const key = `${quotaType}:${keyIds.join(':')}`
        const current = _.get(state.unlocks, key, {})
        current.loading = loading
        _.set(state.unlocks, key, current)
    },
    addPending(state, key) {
        state.pending.push(key)
    },
    clearPending(state) {
        state.pending.length = 0
    },
    setBatchTimer(state, timer) {
        state.batchTimer = timer
    },
    clearBatchTimer(state) {
        state.batchTimer = null
    },
    addRevealPending(state, key) {
        state.revealPending.push(key)
    },
    clearRevealPending(state) {
        state.revealPending.length = 0
    },
    setRevealBatchTimer(state, timer) {
        state.revealBatchTimer = timer
    },
    clearRevealBatchTimer(state) {
        state.revealBatchTimer = null
    },
}

const actions = {

    fetchRevealStatus({ state, commit }, { quotaType, keyIds }) {

        const key = `${quotaType}:${keyIds.join(':')}`


        if (_.get(state.unlocks, key)) {
            return Promise.resolve(_.get(state.unlocks, key))
        }

        commit('addPending', key)

        return new Promise((resolve, reject) => {
            const startBatch = () => {
                const keys = Array.from(state.pending)
                commit('clearPending')
                commit('clearBatchTimer')

                return this.$axios
                    .post('/quota/unlocks/check', {
                        items: keys.map((k) => {
                            let keyParts = k.split(':')
                            let itemQuotaType = keyParts[0]
                            let itemResourceType = keyParts[1]
                            let itemKeyIds = keyParts.slice(2, keyParts.length)
                            return {
                                quotaType : itemQuotaType,
                                resourceType : itemResourceType,
                                resourceId : `${itemKeyIds.join(':')}`,
                            }
                        }),
                    })
                    .then(({ data }) => {
                        data.payload.items.forEach((item) => {
                            commit('unlocks:set', {
                                quotaType : item.quotaType,
                                keyIds : [item.resourceType].concat(item.resourceId.split(':')),
                                data: { ...item.payload, state: 'checked' },
                            })
                        })
                        return _.get(state.unlocks, key)
                    })
            }

            if (state.batchTimer) {
                clearTimeout(state.batchTimer)
            }

            const timer = setTimeout(async () => {
                try {
                    const result = await startBatch()
                    resolve(result)
                } catch (error) {
                    reject(error)
                }
            }, 1000)

            commit('setBatchTimer', timer)
        })
    },

    bulkFetchRevealStatus({ commit }, { quotaType, items }) {
        const revealItems = items.map((item) => ({
            quotaType : quotaType,
            resourceType : item[0],
            resourceId : `${item.slice(1, item.length).join(':')}`,
        }))

        return this.$axios.post('/quota/unlocks/check', { items : revealItems }).then(({ data }) => {
            data.payload.items.forEach((item) => {
                commit('unlocks:set', {
                    quotaType: item.quotaType,
                    keyIds : [item.resourceType].concat(item.resourceId.split(':')),
                    data: { ...item.payload, state: 'checked' },
                })
            })
            return data.payload.items
        })
    },

    reveal({ state, commit }, { quotaType, keyIds }) {
        const key = `${quotaType}:${keyIds.join(':')}`

        commit('unlocks:setRevealLoading', {
            quotaType : quotaType,
            keyIds : keyIds,
            loading: true,
        })

        commit('addRevealPending', key)

        return new Promise((resolve, reject) => {
            const startBatch = () => {
                const keys = Array.from(state.revealPending)
                commit('clearRevealPending')
                commit('clearRevealBatchTimer')

                return this.$axios
                    .put('/quota/unlocks/reveal', {
                        items: keys.map((k) => {
                            let keyParts = k.split(':')
                            let itemQuotaType = keyParts[0]
                            let itemResourceType = keyParts[1]
                            let itemKeyIds = keyParts.slice(2, keyParts.length)
                            return {
                                quotaType : itemQuotaType,
                                resourceType : itemResourceType,
                                resourceId : `${itemKeyIds.join(':')}`,
                            }
                        }),
                    })
                    .then(({ data }) => {
                        data.payload.items.forEach((item) => {
                            const ids = [item.resourceType].concat(item.resourceId.split(':'))
                            commit('unlocks:set', {
                                quotaType : item.quotaType,
                                keyIds : ids,
                                data: { ...item.payload, state: 'revealed' },
                            })
                            commit('unlocks:setRevealLoading', {
                                quotaType : item.quotaType,
                                keyIds : ids,
                                loading: false,
                            })
                        })
                        resolve(data.payload.items)
                    })
                    .catch((error) => {
                        keys.forEach((item) => {
                            const keyParts = item.split(':')
                            commit('unlocks:setRevealLoading', {
                                quotaType : keyParts[0],
                                keyIds : keyParts.slice(1, keyParts.length),
                                loading: false,
                            })
                        })

                        if (api.isQuotaError(error)) {
                            this.$errorHandler(error)
                        }
                    })
            }

            if (state.revealBatchTimer) {
                clearTimeout(state.revealBatchTimer)
            }

            const timer = setTimeout(() => startBatch(), 1000)
            commit('setRevealBatchTimer', timer)
        })
    },

    bulkReveal({ commit }, { quotaType, items }) {
        const itemsToReveal = items.map((item) => ({
            quotaType : quotaType,
            resourceType : item[0],
            resourceId : `${item.slice(1, item.length).join(':')}`,
        }))

        commit('setRevealingBulk', true)

        return this.$axios
            .put('/quota/unlocks/reveal', { items : itemsToReveal })
            .then(({ data }) => {
                data.payload.items.forEach((item) => {
                    commit('unlocks:set', {
                        quotaType: item.quotaType,
                        keyIds : [item.resourceType].concat(item.resourceId.split(':')),
                        data: { ...item.payload, state: 'revealed' },
                    })
                })
                return data.payload
            }).catch((error) => {
                items.forEach((item) => {
                    commit('unlocks:setRevealLoading', {
                        quotaType : item.quotaType,
                        keyIds : item.slice(1, item.length),
                        loading: false,
                    })
                })

                if (api.isQuotaError(error)) {
                    this.$errorHandler(error)
                }
            })
            .finally(() => {
                commit('setRevealingBulk', false)
            })
    },

    clearRevealStatus({ state }, { quotaType, keyIds }) {
        const key = `${quotaType}:${keyIds.join(':')}`

        if (_.get(state.unlocks, key)) {
            return Promise.resolve(_.unset(state.unlocks, key))
        }

        return
    },

    fetchRemainingQuota({ state }, { organizationId}) {
        return this.$axios
            .get(`/organizations/${organizationId}/quota/remaining`)
            .then(({ data }) => {
                return data.payload
            }).catch((error) => {
                return 0
            })
    },
}

const getters = {
    unlocks: (state) => state.unlocks,
    isRevealingBulk: (state) => state.isRevealingBulk,
}

export default {
    state,
    mutations,
    actions,
    getters,
}
